import { render, staticRenderFns } from "./IconImport.vue?vue&type=template&id=a7f20dac&functional=true&"
import script from "./IconImport.vue?vue&type=script&lang=js&"
export * from "./IconImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports